import {useEffect} from 'react';
import {setDirtyForm} from '../store/header/header.slice';
import {useAppDispatch} from '../store/hooks';

const useOnUnsavedChanges = (
    dirty: boolean
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dirty ? dispatch(setDirtyForm(true)) :
      dispatch(setDirtyForm(false));

    return () => {
      dispatch(setDirtyForm(false));
    };
  }, [dirty]);
};

export default useOnUnsavedChanges;
